import intlTelInput from 'intl-tel-input';
import utils from 'intl-tel-input/build/js/utils';
import 'intl-tel-input/build/css/intlTelInput.css';

import classNames from "classnames";
import { validate, validatePhone } from "../../utils/validate";
import { DComponent } from "../DComponent";
import { GLOBAL_CONSTANTS } from '../../global/constants';

export default class PhoneNumber extends DComponent {
  constructor({
    parent,
    id,
    label = "",
    type = "",
    name = "",
    maxlength = 250,
    invalid = "",
    tabIndex = "",
    placeholder = "",
    isRequired = false,
    className = "",
    autoScroll = false,
    scrollPadding,
    scrollParent,
    options = {},
    onKeyup = () => { },
    onChange = () => { },
    onDialCode = () => { },
    inline = false,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("PhoneNumber", className, {
        "is-required": isRequired,
        "not-inline": !inline
      }),
      type: type,
      label: label,
      name: name,
      tabIndex: tabIndex,
      invalid: invalid,
      maxlength: maxlength,
      placeholder: placeholder ? `[placeholder]${placeholder}` : "",
      autoScroll: autoScroll ? " autoscroll" : "",
      scrollPadding: scrollPadding !== undefined ? ` scrollpadding="${scrollPadding}"` : "",
      scrollParent: scrollParent ? ` scrollparent="${scrollParent}"` : "",
    }, true);
    this.placeholder = placeholder;
    this.isRequired = isRequired;
    this.options = options;
    this.onKeyup = onKeyup;
    this.onChange = onChange;
    this.onDialCode = onDialCode;
    this.phoneField = undefined;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "PhoneNumber");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    try {
      // const phoneField = document.querySelector("#" + this.id + "_phone");
      const phoneField = $("input", this.element)[0];
      let options = {
        ...this.options
      }
      this.phoneField = intlTelInput(phoneField, {
        initialCountry: "auto",
        utilsScript: utils,
        separateDialCode: true,
        ...options
      });

      phoneField.addEventListener("countrychange", (e) => {
        let phoneCountry = this.getCountry();
        phoneCountry && typeof this.onDialCode == "function" && this.onDialCode(phoneCountry);
        if (this.phoneField.getNumber()) {
          this.isValidate(true);
        }
        // this.clearInput();
      });
    } catch (error) {
      console.error(error);
    }

    $("input", this.element).on('keyup', (event) => {
      event.currentTarget.value = event.currentTarget.value.replace(/[^(\d\-+ )]/g, "");
      if (!event.currentTarget.value) {
        $("input", this.element).parent().removeClass("is-invalid");
      } else {
        this.isValidate(true);
      }
    });

    $("input", this.element).on('change', (event) => {
      let phoneNumber = this.getNumber();
      phoneNumber && typeof this.onChange == "function" && this.onChange(phoneNumber);
    });
  }

  getNumber() {
    let result = (this.phoneField && this.phoneField.getNumber() ? this.phoneField.getNumber() : "") || "";
    return result.toUpperCase();
  }

  setNumber(value) {
    this.phoneField && this.phoneField.setNumber(value);
    $("input", this.element).trigger("change");
    if (!value) {
      $("input", this.element).parent().removeClass("is-invalid");
    }
  }

  getCountry() {
    let result = (this.phoneField && this.phoneField.getSelectedCountryData().iso2 ? this.phoneField.getSelectedCountryData().iso2 : "") || "";
    return result.toUpperCase();
  }

  setCountry(value) {
    try {
      this.phoneField && this.phoneField.setCountry(value);
    } catch (_) { }
  }

  clearInput() {
    $("input", this.element).parent().removeClass("is-invalid");
    $("input", this.element).val("");
  }

  isValidate(isShowValid = true, isFocus = true) {
    if (!this.isRequired && !this.getNumber()) return true;
    return validate({ type: GLOBAL_CONSTANTS.INPUT_TYPE.PHONE, selector: $("input", this.element), validator: validatePhone, showInvalid: isShowValid, customVal: this.phoneField, isFocus: isFocus });
  }
}